import { MATRIX_BACKEND } from '@/remotes';
import { useDataFormStore } from '@/stores/form';
import { useNewDataFormCargoPickUpStore } from '@/stores/newFormCargoPickUp';

export async function useFetchSuitableOfficesCalculator(typeCities) {
  const dataForm = useDataFormStore();
  const newDataForm = useNewDataFormCargoPickUpStore();

  const { cargoInformation } = dataForm;

  const isAcceptance = typeCities === 'acceptanceCargo';

  const params = new URLSearchParams();
  const city = isAcceptance ? dataForm.sender.cityFrom : dataForm.consignee.cityTo;
  const typeOfCargosNew = [
    {
      id: 1,
      title: 'Стандарт',
    },
    {
      id: 2,
      title: 'Цилиндры',
    },
    {
      id: 3,
      title: 'Шины',
    },
  ];
  const { id: cargoTypeId } = typeOfCargosNew.find((type) => type.title === dataForm.cargoInformation.typeOfCargo);

  const weight = Number(cargoInformation.cargoWeight);

  if (!city) {
    if (isAcceptance) {
      newDataForm.fetchedSuitableOffices.pickUp = [];
      dataForm.calculator.isCargoPickup = '';
    } else {
      newDataForm.fetchedSuitableOffices.delivery = [];
      dataForm.calculator.isDelivery = '';
    }
    return;
  }

  if (isAcceptance) {
    params.append('acceptanceCargo', true);
  } else {
    params.append('issuanceOfCargo', true);
  }

  params.append('cityId', city.id);
  params.append('cargoType', cargoTypeId);

  const cargoDimensions = cargoInformation.cargoDimensions;
  const sizeOfCargoCylinder = dataForm.cargoInformation.sizeOfCargoCylinder;

  switch (cargoTypeId) {
    case 1:
      params.append('weight', weight);

      params.append('length', Number(cargoDimensions.length));
      params.append('width', Number(cargoDimensions.width));
      params.append('height', Number(cargoDimensions.height));

      break;
    case 2:
      params.append('weight', weight);

      params.append('diameter', Number(sizeOfCargoCylinder.diameter));
      params.append('height', Number(sizeOfCargoCylinder.height));

      break;

    default:
      break;
  }

  try {
    const { data } = await MATRIX_BACKEND.get('/api/public/suitable-offices', { params });
    if (data.length > 0) {
      if (isAcceptance) {
        newDataForm.fetchedSuitableOffices.pickUp = data;
      } else {
        newDataForm.fetchedSuitableOffices.delivery = data;
      }
    } else {
      if (isAcceptance) {
        newDataForm.fetchedSuitableOffices.pickUp = [];
        dataForm.calculator.isCargoPickup = 'Забор груза';
      } else {
        newDataForm.fetchedSuitableOffices.delivery = [];
        dataForm.calculator.isDelivery = 'Доставка до адреса';
      }
    }
  } catch {
    if (isAcceptance) {
      newDataForm.fetchedSuitableOffices.pickUp = [];
      dataForm.calculator.isCargoPickup = 'Забор груза';
    } else {
      newDataForm.fetchedSuitableOffices.delivery = [];
      dataForm.calculator.isDelivery = 'Доставка до адреса';
    }
  }
}
